import { Card, Divider, Typography, Row, Col, Tag } from "antd";
import React, { useState, useEffect } from "react";
import Dashboard from "../../../components/Wash/Dashboard/Dashboard";
import MasterBinService from "../../../services/Shared-Service/MasterBinService";
import ManageBinService from "../../../services/ManageBinService";
import LoadingSpin from "../../../components/loadingSpin/LoadingSpin";
import "../../../styles/global-ui.css";

const WashDashboardPage = ({ userData }) => {
  const [transitBins, setTransitBins] = useState([]);
  const [washingBins, setWashingBins] = useState([]);
  const [loading, setLoading] = useState(true);

  const getArrayFromResponse = (res) => {
    if (Array.isArray(res)) return res;
    if (Array.isArray(res?.data)) return res.data;
    if (Array.isArray(res?.data?.data)) return res.data.data;
    if (Array.isArray(res?.result)) return res.result;
    return [];
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const [transitRes, washingRes] = await Promise.all([
          MasterBinService.masterBin_get_bins_details(),
          ManageBinService.getBinData(),
        ]);

        console.log("transitRes:", transitRes);
        console.log("washingRes:", washingRes);

        setTransitBins(getArrayFromResponse(transitRes));
        setWashingBins(getArrayFromResponse(washingRes));
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
        setTransitBins([]);
        setWashingBins([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const washingOnly = washingBins.filter((bin) => {
    const location = String(bin?.bin_location || "").trim().toLowerCase();
    const full = String(bin?.bin_full || "").trim().toLowerCase();

    return location.includes("washing") && (full === "yes" || full === "1" || full === "true");
  });

  const totalWashingBins = washingOnly.length;

  const totalWashingPcs = washingOnly.reduce(
    (sum, bin) => sum + Number(bin?.total_quantity || 0),
    0
  );

  const totalTransitBins = transitBins.length;

  const totalTransitPcs = transitBins.reduce(
    (sum, bin) => sum + Number(bin?.total_quantity || 0),
    0
  );

  const today = new Date();
  const formattedDate = `${today
    .getDate()
    .toString()
    .padStart(2, "0")}.${(today.getMonth() + 1)
    .toString()
    .padStart(2, "0")}.${today.getFullYear()}`;

  return (
    <div className="page-container" style={{ position: "relative" }}>
      {loading && (
        <div className="dashboard-overlay-loader">
          <LoadingSpin />
        </div>
      )}

      <div className="page-header">
        <div className="page-title-wrap">
          <Typography.Title level={3} className="page-title">
            Washing Center Dashboard
          </Typography.Title>
          <Typography.Text className="page-subtitle">
            Washing center overview and bin activity
          </Typography.Text>
        </div>

        <Tag className="filter-tag" color="blue">
          Date: {formattedDate}
        </Tag>
      </div>

      <Divider className="page-divider" />

      {/* <div className="compact-stats" style={{ marginBottom: 24 }}>
        <Row gutter={[16, 8]} justify="center">
          <Col xs={12} sm={6}>
            <div className="compact-stat-item">
              <div className="compact-stat-value" style={{ color: "#0f172a" }}>
                {totalWashingBins}
              </div>
              <div className="compact-stat-label">Washing Bins</div>
            </div>
          </Col>

          <Col xs={12} sm={6}>
            <div className="compact-stat-item">
              <div className="compact-stat-value" style={{ color: "#0f766e" }}>
                {totalWashingPcs}
              </div>
              <div className="compact-stat-label">Washing Pieces</div>
            </div>
          </Col>

          <Col xs={12} sm={6}>
            <div className="compact-stat-item">
              <div className="compact-stat-value" style={{ color: "#7c2d12" }}>
                {totalTransitBins}
              </div>
              <div className="compact-stat-label">In Transit Bins</div>
            </div>
          </Col>

          <Col xs={12} sm={6}>
            <div className="compact-stat-item">
              <div className="compact-stat-value" style={{ color: "#7c3aed" }}>
                {totalTransitPcs}
              </div>
              <div className="compact-stat-label">Transit Pieces</div>
            </div>
          </Col>
        </Row>
      </div> */}

      <Card className="modern-card">
        <Dashboard
          userData={userData}
          transitBins={transitBins}
          washingBins={washingBins}
          loading={loading}
        />
      </Card>
    </div>
  );
};

export default WashDashboardPage;